module.exports = __webpack_public_path__ + "img/afkwirtualnebiuro.c5dc52f8.png";